import { useContext, useState } from 'react';
import { FiltersContext } from 'organisms/Filters/Context';
import { useTranslations } from 'modules/i18n/useTranslations';
import { Facets, IFilter, IFilterParam } from 'commerce/factFinder/types';

export const useFilters = () => {
  return useContext(FiltersContext);
};

export const useFilterState = ({
  initFilters,
  exclude = [],
  currencySymbol = '',
}: {
  initFilters: IFilterParam[];
  exclude: string[];
  currencySymbol?: string;
}) => {
  const t = useTranslations();
  return useState<IFilter[]>(
    initFilters
      .filter((f) => !exclude.includes(f.name))
      .flatMap(
        (filter) =>
          filter.values?.map((v) => {
            if (filter.name === Facets.PRICE) {
              return {
                type: filter.name,
                // convert to expecting filter type
                value: v.value.match(/\d+/g)?.map((v) => Number(v)) || [],
                displayValue: v.value.replace(
                  /.{1}(\d+)\,(\d+).{1}/,
                  `$1 - $2 ${currencySymbol}`,
                ),
              };
            }

            if (filter.name === Facets.RATING) {
              const value = v.value.match(/\d+/g)?.map((v) => Number(v)) || [];

              return {
                type: filter.name,
                value,
                displayValue: t('search.filters.ratingChip', {
                  value: value[0],
                }),
              };
            }

            return {
              type: filter.name,
              value: v.value,
              displayValue: v.value,
            };
          }) || [],
      ),
  );
};
